import { UserBusinessFeatures } from '../entity/business-features.entity';

export class UKMarket implements UserBusinessFeatures {
  getUserAddressFeatures() {
    return {
      showApartmentBeforeStreet: true,
    };
  }
}
